module.exports = __webpack_public_path__ + "static/img/SearchDetailWork4.17a899f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailWork4.png
// module id = 780
// module chunks = 0